// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__fxre7","itemTitle":"ClientEmergencyInfo_itemTitle__1oBXZ","itemText":"ClientEmergencyInfo_itemText__OzDSz"};